import { RecurringSchedule } from 'mbs-ui-shared@models/ScheduleModel';
import { ScheduleStepValue } from 'mbs-ui-shared@models/backup/schedule-models';
import { StorageConnection } from 'mbs-ui-shared@models/storge-connections';
import moment from 'moment/moment';
import { DayOfWeek } from 'wizards/models/DayOfWeek.enum';
import { WeekNumber } from 'wizards/models/WeekNumber.enum';
import { AdvancedOptionsFlags } from 'wizards/models/advanced-options-models';
import { AppAwareStepValue } from 'wizards/models/app-aware-models';
import { ArchiveConsistencyStepValue } from 'wizards/models/archive-consistency-step-value';
import { BaseFormModels } from 'wizards/models/base/base-form-models';
import { CompressionEncryptionStepValue } from 'wizards/models/compression-encription-models';
import { RetentionPolicyStepValue } from 'wizards/models/retention-policy-models';
import { ScheduleAdvancedStepValue, ScheduleFormSettings } from 'wizards/models/schedule-advanced-models';
import { SelectVirtualDisksStepValue, VirtualDisksSelectedType } from 'wizards/models/select-virtual-disks-models';
import { SelectVirtualMachinesStepValue, VirtualMachinesSelectedType } from 'wizards/models/select-virtual-machines-models';
import { SimpleScheduleStepValue } from 'wizards/models/simple-schedule-models';

export class VmwareHyperVBaseModel extends BaseFormModels {
  advancedOptionsFlags: AdvancedOptionsFlags = {
    ExcludePossible: true,
    UseS3AccelerationPossible: false,
    AzureAccessTierType: false,
    StorageClassSettingPossible: false,
    SyntheticFullSettingPossible: false,
    IgnoreBadSectorsPossible: true,
    DisableVSSPossible: true,
    UseVSSPossible: true,
    PrefetchBlockCountPossible: true,
    BlockSizeSettingPossible: true
  };

  StoragesArray: StorageConnection[] = [];

  selectVirtualMachinesStep: SelectVirtualMachinesStepValue = {
    type: VirtualMachinesSelectedType.All,
    machines: [],
    machinesFullFormat: [],
    valid: true
  };
  appAwareStep: AppAwareStepValue = {
    settings: [],
    valid: true
  };
  selectVirtualDisksStep: SelectVirtualDisksStepValue = {
    type: VirtualDisksSelectedType.Selected,
    disks: [],
    allDisks: [],
    valid: true
  };

  archiveConsistencyStep: ArchiveConsistencyStepValue = { useFullConsistencyCheck: true, valid: true };
  compressionEncryptionStep: CompressionEncryptionStepValue = {
    UseCompression: true,
    UseEncryption: false,
    EncryptionAlgorithm: 3,
    EncryptionKeySize: 256,
    EncryptionPassword: '',
    valid: true
  };
  scheduleStep: ScheduleStepValue = {
    ScheduleType: 'noschedule',
    StopAfterEnabled: false,
    stopAfterHours: 0,
    stopAfterMinutes: 0,
    ForceMissedSchedule: false,
    incrementalData: {
      enabled: true,
      recurringPeriod: 'Monthly',
      weeklyDayOfWeek: [],
      occurrence: WeekNumber.First,
      dayOfWeek: DayOfWeek.Wednesday,
      dayOfMonthCount: 1,
      dailyFreqPeriodOption: 'OccursAt',
      occursAtTime: '00:00',
      occursEveryCount: 1,
      occursEveryPeriod: 'hours',
      occursEveryFromTime: '00:00',
      occursEveryToTime: '00:00'
    },
    fullBackupData: {
      enabled: false,
      recurringPeriod: 'Monthly',
      weeklyDayOfWeek: [],
      occurrence: WeekNumber.First,
      dayOfWeek: DayOfWeek.Wednesday,
      dayOfMonthCount: 1,
      dailyFreqPeriodOption: 'OccursAt',
      occursAtTime: '00:00'
    },
    syncBeforeRun: false,
    valid: true
  };
  retentionPolicyStep: RetentionPolicyStepValue = {
    RetentionUseDefaultSettings: true,
    deleteVersionsOlderThanCount: 1,
    deleteVersionsOlderThanPeriod: 2,
    intelligentRetention: false,
    GFSPolicySettings: {
      enabled: false,
      enabledImmutability: false,
      weekly: { enabled: false, storePeriod: 2 },
      monthly: { enabled: false, storePeriod: 4 },
      yearly: { enabled: false, storePeriod: 2, takeBackupFromMonth: 1 }
    },
    valid: true
  };

  simpleScheduleStep?: SimpleScheduleStepValue;
  scheduleAdvancedStep?: ScheduleAdvancedStepValue;

  public date = moment(new Date()).toDate();
  public time = moment(this.date).format('HH:mm:ss');
  constructor(
    public isUnix = false,
    public isNBF = false
  ) {
    super(isNBF, isUnix);

    this.advancedOptionsFlags = {
      AlwaysUseVSSPossible: !isUnix,
      BackupNTFSPermissionsPossible: !isUnix,
      StorageClassSettingPossible: false,
      UseFastNtfsScanPossible: !isUnix,
      UseS3AccelerationPossible: false,
      UseVSSPossible: !isUnix,
      ExcludePossible: false,
      AzureAccessTierType: false,
      SyntheticFullSettingPossible: !isUnix,
      IgnoreBadSectorsPossible: false,
      DisableVSSPossible: false,
      PrefetchBlockCountPossible: false,
      BlockSizeSettingPossible: false
    };

    if (!this.isNBF) {
      this.scheduleAdvancedStep = {
        forceFull: new ScheduleFormSettings(false, new RecurringSchedule(isUnix)),
        blockLevel: new ScheduleFormSettings(),
        scheduleDiff: new ScheduleFormSettings(null, null),
        scheduleTLog: new ScheduleFormSettings(null, null),
        valid: true
      };
      this.simpleScheduleStep = {
        startFromDate: moment().format('YYYY-MM-DDT00:00:00'),
        startFromTime: this.time,
        scheduleTemplate: '',
        fullScheduleEnabled: true,
        fullBackupEveryHours: 168,
        fullBackupEveryMinutes: 0,
        blockLevelBackup: true,
        blockLevelBackupEveryHours: 24,
        blockLevelBackupEveryMinutes: 0,
        scheduleDiffEnabled: false,
        differentialBackupEveryHours: 0,
        differentialBackupEveryMinutes: 0,
        scheduleTLogEnabled: false,
        tLogBackupEveryHours: 0,
        tLogBackupEveryMinutes: 0,
        valid: true
      };
    }
  }
}
